import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, onBeforeMount, ref, watch } from 'vue';
import store from '@/store';
import { Provider } from '@/utils/PodProvider.enum';
import { getSettings } from '@/api/storesApp/settings';
import { getPodProviders } from '@/api/admin/podProvider';
import StoreSelector from '@/components/StoreSelector/StoreSelector.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PodSelector',
  emits: ['select'],
  setup(__props, { emit }) {

const printifyLabel = 'Printify';
const printfulLabel = 'Printful';
const myProductBasesId = 5;
const podProviderThumbnailPath = 'app/images_pod';



const availableProviders: Ref<string[]> = ref([]);
const checkingProviders = ref(false);
const storeUrl = ref('');

const podProviders: Ref<
    {
        podId: number;
        key: string;
        label: string;
        image: string;
        description: string;
    }[]
> = ref([]);

const user = computed(() => store.state.user);

const providers = computed(() => {
    return podProviders.value.filter((p) => availableProviders.value.includes(p.label));
});

const isManualPod = computed(() => {
    return (pod = '') => ![Provider.PRINTFUL, Provider.PRINTIFY].includes(pod as Provider);
});

watch(storeUrl, () => checkProviders());

onBeforeMount(async () => {
    await loadPodProviders();
    await checkProviders();
});

const loadPodProviders = async () => {
    const providers = await getPodProviders();

    podProviders.value = providers.map((provider) => ({
        podId: provider.id,
        key: provider.apiKeyReference,
        label: provider.name,
        image: `${process.env.VUE_APP_CLOUDFRONT_URL}/${podProviderThumbnailPath}/${provider.imageURL}`,
        description: `Select products from ${provider.name} catalog`
    }));
};

const checkProviders = async () => {
    try {
        if (storeUrl.value) {
            checkingProviders.value = true;
            availableProviders.value = [];

            const settings = await getSettings(storeUrl.value);
            if (settings.printful.enabled && settings.printful.apiKey) {
                availableProviders.value.push(printfulLabel);
            }
            if (settings.printify.enabled && settings.printify.apiKey) {
                availableProviders.value.push(printifyLabel);
            }
            podProviders.value
                .filter(
                    (provider) =>
                        provider.label !== printifyLabel &&
                        provider.label !== printfulLabel &&
                        provider.podId !== myProductBasesId
                )
                .forEach((provider) => {
                    availableProviders.value.push(provider.label);
                });
        }
    } finally {
        checkingProviders.value = false;
    }
};

const podSelected = (podKey: string, podId: number) => {
    const pod = !isManualPod.value(podKey as string) ? podKey : '';
    emit('select', {
        pod,
        storeUrl: storeUrl,
        podId: podId
    });
};

return { __sfc: true,printifyLabel, printfulLabel, myProductBasesId, podProviderThumbnailPath, emit, availableProviders, checkingProviders, storeUrl, podProviders, user, providers, isManualPod, loadPodProviders, checkProviders, podSelected, StoreSelector }
}

})